import _ from '../../core/utils'

class SubmitClass {

    _startLoading( form ) {
        _.addClass( document.documentElement, 'is--loading' )
        _.addClass( _.select( '.fl__submit', form ), 'is--loading' )
    }
    _endLoading( form ) {
        _.removeClass( document.documentElement, 'is--loading' )
        _.removeClass( _.select( '.fl__submit', form ), 'is--loading' )
    }
}

const SUBMIT = new SubmitClass()
export default SUBMIT